"use client";

import { usePairedIntersectionObserver } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/__internal__/ProductTileViewImpressionContext";
import { useUnmountProductTileContext } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/__internal__/UnmountProductTileContext";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import { useEffect } from "react";

interface ITrackProductTileProps {
  ref: undefined | ((element: HTMLElement | null | undefined) => void);
  "data-product-token": string;
  "data-product-promoted-by": string;
  "data-product-impression-id": string;
}

export const useProductTileViewImpression = ({
  productToken = "",
  promotedBy,
  impressionId = "",
}: {
  productToken?: string;
  promotedBy?: Array<keyof typeof IProduct.PromotedType>;
  impressionId?: string;
}): ITrackProductTileProps => {
  const handleIntersectionObserverCallbackRef = usePairedIntersectionObserver();
  const { onUnmount } = useUnmountProductTileContext();

  const promotedByString = promotedBy?.join(",") ?? "";

  useEffect(() => {
    return () => {
      onUnmount(productToken, impressionId);
    };
  }, [productToken, impressionId, onUnmount]);

  return {
    ref: handleIntersectionObserverCallbackRef,
    "data-product-impression-id": impressionId,
    "data-product-token": productToken,
    "data-product-promoted-by": promotedByString,
  };
};
